<template>
  <div>
    <input ref="input" type="file" name="image" accept="image/*" @change="setImage" />

    <figure class="m-auto rounded-full w-180d relative">
      <img class="rounded-full h-full w-full" :src="imgSrc" />
      <div
        class="bg-primary inline-block rounded-full absolute edit right-0 cursor-pointer"
        @click="popupActive = true"
      >
        <i class="material-icons text-white p-3"> edit </i>
      </div>
    </figure>

    <vs-popup class="holamundo" :title="$t(`PROFILEVIEW.cropImage`)" :active.sync="popupActive">
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
          <img id="image" :src="imgSrc" />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
          <div class="flex flex-col justify-around h-full">
            <vs-button color="primary" type="border" @click="toCrop">
              <i class="material-icons"> content_cut </i>
            </vs-button>
            <vs-button class="my-2" color="primary" type="border" @click="upload">
              <i class="material-icons"> file_upload </i>
            </vs-button>
            <vs-button class="mb-2" color="primary" type="border" @click="zoomPlus">
              <i class="material-icons"> zoom_in </i>
            </vs-button>
            <vs-button color="primary" type="border" @click="zoomMinus">
              <i class="material-icons"> zoom_out </i>
            </vs-button>
          </div>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
export default {
  props: {
    value: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      Cropper: null,
      popupActive: false
    };
  },
  mounted() {
    this.Cropper = new Cropper(document.getElementById("image"), { aspectRatio: 16 / 15, autoCrop: false });
  },
  methods: {
    setImage(e) {
      const file = e.target.files[0];

      if (file.type.indexOf("image/") === -1) {
        alert("Please select an image file");
        return;
      }

      if (typeof FileReader === "function") {
        const reader = new FileReader();

        reader.onload = event => {
          this.imgSrc = event.target.result;
          this.Cropper.replace(event.target.result);
        };

        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    toCrop() {
      this.imgSrc = this.Cropper.getCroppedCanvas().toDataURL();
      this.popupActive = false;
    },
    upload() {
      this.$refs.input.click();
    },
    zoomPlus() {
      this.Cropper.zoom(0.1);
    },
    zoomMinus() {
      this.Cropper.zoom(-0.1);
    }
  },
  computed: {
    imgSrc: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#image {
  display: block;

  /* This rule is very important, please don't ignore this */
  max-width: 100%;
}
.edit {
  top: 125px;
}

.w-180d {
  width: 180px;
  height: 180px;
}
.w-180 {
  width: 200px;
  height: 200px;
}
input[type="file"] {
  display: none;
}
</style>
